import React from "react";
import CancelIcon from '@mui/icons-material/Cancel'
import { buttonStyle } from "./HeaderSearchTextCancelButton.styles";

interface HeaderSearchTextCancelButtonProps {
  onClick?: () => void
}

export const HeaderSearchTextCancelButton: React.FC<HeaderSearchTextCancelButtonProps> = ({
  onClick,
}) => {
  return (
    <CancelIcon
      fontSize={'small'}
      sx={buttonStyle}
      onClick={onClick}
    />
  )
}